/*
 * @Description:
 * @Date: 2022-04-14 17:18:40
 * @LastEditTime: 2022-04-26 23:31:51
 */
import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser'
import { b2cPolicies } from './policies'
// import { apiConfig } from "./apiConfig";

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
    authority: b2cPolicies.authorities.signIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    navigateToRequestUrl: false,
    redirectUri: process.env.VUE_APP_AZURE_REDIRECT_HOME, // Must be registered as a SPA redirectURI on your app registration
    postLogoutRedirectUri: process.env.VUE_APP_AZURE_REDIRECT, // Must be registered as a SPA redirectURI on your app registration
  },

  cache: { cacheLocation: 'sessionStorage' },

  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error('Error', message)
            return
          case LogLevel.Warning:
            console.warn('Warning', message)
            return
          default:
            return
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
}

export const msalInstance = new PublicClientApplication(msalConfig as Configuration)

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['openid'],
}

// SignUpRequest
export const signupRequest = {
  authority: b2cPolicies.authorities.signUp.authority,
  scopes: ['openid'],
  extraQueryParameters: {},
}

// ResetPasswordRequest
export const resetPasswordRequest = {
  authority: b2cPolicies.authorities.resetPassword.authority,
  //scopes: ["openid", ...apiConfig.b2cScopes],
  scopes: ['openid'],
}

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}
